import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class NavigationService {

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  navigateTo(route: string) {
    // this._utilitiesService.addAction('Init');
    this.router.navigate(['/' + route]);
  }

  currentPage() {
    if (this.activatedRoute.snapshot.firstChild &&
        this.activatedRoute.snapshot.firstChild.url &&
        this.activatedRoute.snapshot.firstChild.url.length > 0) {
      return this.activatedRoute.snapshot.firstChild.url[0].path;
    } else {
      return '';
    }
  }
}
